import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { useHandleMutation } from 'hooks';
import { useResetMutation } from 'store/api/course-submissions';

import { Dialog } from '../dialog';
import { Button } from '../button';

import { ResetWaiverProps } from './types';

export const ResetWaiver = ({
  open,
  onClose,
  children,
  onSuccess,
}: PropsWithChildren<ResetWaiverProps>) => {
  const [reset, mutation] = useResetMutation();
  const { t } = useTranslation(['common', 'header']);

  useHandleMutation({
    ...mutation,
    onSuccess: () => {
      onClose();
      onSuccess?.();
    },
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('header:resetWaiverTitle')}
      actions={
        <>
          <Button onClick={onClose} variant="outlined">
            {t('common:cancel')}
          </Button>
          <Button
            color="error"
            onClick={() => reset()}
            disabled={mutation.isLoading}
          >
            {t('common:continue')}
          </Button>
        </>
      }
    >
      {children}
    </Dialog>
  );
};
